<template>
  <footer id="footer" class="footer_area">
    <div class="container">
      <div
        class="footer_wrapper text-center d-lg-flex align-items-center justify-content-between"
      >
        <p class="credit">&copy; 2022 <strong>Kelompok 10</strong><br /></p>
        <div class="footer_social pt-15">
          <ul>
            <li>
              <a href="#"><i class="lni lni-facebook-original"></i></a>
            </li>
            <li>
              <a href="#"><i class="lni lni-twitter-original"></i></a>
            </li>
            <li>
              <a href="#"><i class="lni lni-instagram-original"></i></a>
            </li>
            <li>
              <a href="#"><i class="lni lni-linkedin-original"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
